module.exports = __webpack_public_path__ + "static/media/two.00270b44.svg";